import { jsx } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/shared/components/buttons/button.tsx
function Button({ className, ...props }) {
	return /* @__PURE__ */ jsx("button", {
		className: cn("media-button", className),
		...props
	});
}
//#endregion
export { Button };

//# sourceMappingURL=button.js.map